<template>
	<div class="fiexd">
		<div class="fiex" v-if="shows">
			<div class="lists" @click="fixedEven()">
				<a>
					<img src="../assets/image/gotop.png" alt="">
				</a>
			</div>
			<div class="lists">
				<a :href="weibo_link" target="_blank">
					<img src="../assets/image/weibo.png" alt="">
				</a>
			</div>
			<div class="lists">
				<a :href="wechat_link" target="_blank">
					<img src="../assets/image/weixin.png" alt="">
				</a>
			</div>
			<!-- -->
			<div class="lists">
				<a :href="shop_link">
					<img src="../assets/image/shops.png" alt="">
				</a>
				<!-- <div class="shopLength" v-if="lang == 'cn'">
					{{length}}
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			shows: {
				type: Boolean,
				default: false
			},
			fatherMethod: {
				type: Function,
				default: null
			}
		},
		data() {
			return {
				shop_link: '',
				wechat_link: '',
				weibo_link: '',
				length: 0,
				len: 0,
				lang: 'cn'
			}
		},
		created() {
			if (localStorage.getItem('languageSet') == 'zh') {
				this.lang = 'en'
			} else {
				this.lang = 'cn'
			}
			this.ajaxFunc();
			this.$fetch('/index/info').then(res => {
				this.shop_link = res.data.shop_link;
				this.wechat_link = res.data.wechat_link;
				this.weibo_link = res.data.weibo_link;
			})
			this.len = localStorage.getItem('length');
		},
		methods: {
			ajaxFunc() {
				if (window.localStorage.getItem('access_token')) {
					this.$fetch('cart/list').then(res => {
						this.length = res.data.length;
					})
				}
			},
			shopCar() {
				this.$router.push({
					path: '/shopCar'
				})
			},
			fixedEven() {
				if (this.fatherMethod) {
					this.fatherMethod();
				}
			}
		}
	}
</script>

<style scoped="scoped">
	.fiex {
		width: 60px;
		height: 300px;
		position: fixed;
		bottom: 25px;
		right: 30px;
		z-index: 999999;
		transition: .3s;
	}

	.lists {
		width: 40px;
		height: 40px;
		margin-top: 10px;
		position: relative;
	}

	.lists>a {
		width: 100%;
	}

	.lists>a>img {
		width: 100%;
		height: 100%;
	}

	.shopLength {
		width: 20px;
		height: 20px;
		background: red;
		position: absolute;
		right: -5px;
		top: -5px;
		border-radius: 50%;
		text-align: center;
		line-height: 20px;
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/components/fiex.vue